<app-loading-animation 
    [show]="isLoading || isDataLoading"
    [size]="'large'" 
    [overlay]="true">
</app-loading-animation>

<div class="drive-email-container" *ngIf="!isDataLoading">
    <form [formGroup]="templateFormGroup">
        <div class="template-container">
            <div class="multi-container"  *ngFor="let each of driveTemplate">
                <div class="p-float-label create-fields">
                    <p-dropdown 
                        placeholder="Select Template" 
                        [options]="allEmailTemplates[each.value]"
                        optionLabel="label" 
                        optionValue="value"
                        [formControlName]="each.value"
                        [autoDisplayFirst]="false"
                    ></p-dropdown>
                    <label for="inputtext">{{ each.label| driveLabelPipe}}</label>
                </div>
            </div>
        </div>
    </form>
</div>